<moti-popover-message
  [infoText]="popoverText"
  [infoHtml]="popoverHtml"
  [delay]="popoverDelay"
>
  <button
    [ngClass]="styleClasses"
    [class.success]="isSuccessful"
    [disabled]="disabled || isSuccessful"
  >
    @if (!isLoading) {
      <div
        class="content"
      >
        <ng-content></ng-content>
      </div>
    } @else {
      <motn-spinner></motn-spinner>

      <div
        class="checkmark icon"
      >
        <i class="fa-solid fa-check"></i>
      </div>
    }
  </button>
</moti-popover-message>
